<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("recipe", 2) }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-recipe" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="searchRecipe"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <FilterByStatusDropdown
          :onSelect="filterIsActive => getRecipesList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(recipe, recipeIndex) in recipes"
        :key="recipeIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ recipe.recipe_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item @click="goToRoute('/fnb/edit-recipe', recipe)">
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-recipe', recipe)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="recipe.recipe_is_active == 'Y' ? true :false"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  recipe.recipe_is_active == 'Y'
                    ? 'active'
                    : recipe.recipe_is_active == 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="recipes.length == 0">
        <h5>No Records Found</h5>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'recipe_name'"
              @click="onSortValue('recipe_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('recipe_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('recipe_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("recipe", 2) }}
          </th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="recipes.length>0">
        <tr v-for="(recipe, recipeIndex) in recipes" :key="recipeIndex">
          <td>{{ recipe.recipe_name }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="recipe.recipe_is_active == 'Y' ? true :false"
                  type="checkbox"
                  class="ios-checkbox"
                     disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  recipe.recipe_is_active == 'Y'
                    ? 'active'
                    : recipe.recipe_is_active == 'N' && 'inactive'
                "
              />
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item @click="goToRoute('/fnb/edit-recipe', recipe)">
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-recipe', recipe)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="2">
            <NoRecords/>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      recipes: [],
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  beforeMount() {
    this.getviewingnumber();
  },
  mounted() {
    this.getRecipesList();
  },
  methods: {
    searchRecipe() {
      this.getRecipesList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getRecipesList();
      } else {
        this.currentPage = event;
        this.getRecipesList();
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getRecipesList();
    },
    getRecipesList: function(filterIsActive = "Y") {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        type: 1,
        filterIsActive
      };
      PosFnbService.GetRecipeList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.recipes = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show("No Recipes Found");
            this.recipes = [];
            this.rows = data.totalRows;
            this.selectedvalue = data.totalRows;
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    goToRoute: function(path, { recipe_id }) {
      this.$router.push({
        path: path,
        query: {
          recipe_id: recipe_id
        }
      });
    },
    /* eslint-disable */

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RecipesComponents/recipes.vue